<template>
<el-form ref="form" :model="menu" label-width="80px" size="mini">
    <el-row>
        <el-col :xs="24" :sm="12">
            <el-form-item :label="msg('菜单名')">
                <el-input v-model="menu.name"></el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
            <el-form-item :label="msg('URL')">
                <el-input v-model="menu.url"></el-input>
            </el-form-item>
        </el-col>
    </el-row>
    <el-row>
        <el-col :xs="24" :sm="12">
            <el-form-item :label="msg('图标')">
                <el-input  v-model="menu.clazz" v-popover:iconPopover :placeholder="msg('请选择图标')" suffix-icon="el-icon-arrow-down">
                    <template slot="prepend"><i :class="['iconfont', menu.clazz?menu.clazz:'']"></i></template>
                </el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
             <el-form-item :label="msg('上级菜单')" >
                <el-input v-model="parent.name" v-popover:menusPopover suffix-icon="el-icon-arrow-down"></el-input>
            </el-form-item>
        </el-col>
    </el-row>

    <el-form-item :label="msg('排序')">
        <el-input v-model="menu.seq" :placeholder="msg('数字越大越靠前')" ></el-input>
    </el-form-item>
  
    <div style="text-align:center;">
        <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
        <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
    </div>

    <el-popover
        ref="iconPopover"
        placement="bottom"
        width="300"
        trigger="focus"
        v-model="iconPopoverVisiable"
        >
        <ul class="icon-list">
            <li v-for="icon in icons" :key="icon.font_class" 
                    @click="iconPopoverVisiable=false; menu.clazz=icon.font_class">
                <i :class="['iconfont', icon.font_class]"></i>
            </li>
        </ul>
    </el-popover>

    <el-popover
            ref="menusPopover"
            placement="bottom"
            width="300"
            trigger="focus"
            v-model="menusPopoverVisiable"
        >
        <el-tree style="height: 400px; overflow-y: auto;" :data="menus" default-expand-all node-key="id" 
            ref="menuTreeSelector" 
            :props="defaultProps" @node-click="selectedMenuNode">
        </el-tree>
    </el-popover>
</el-form> 
</template>

<script>
export default {
  name: 'MenuEdit',
  data(){
    return{
        icons:this.$kit.icons,
        iconPopoverVisiable: false,
        menusPopoverVisiable:false,
        defaultProps:{label: "name"}, 
    }
  },
  props:{
      menus:Array,
      parent: Object,
      menu: Object,
  },
  mounted: function(){
       
  },
  methods:{
    onSubmit(){

        var url = null;
        if(this.menu.id==null){
            url = this.$kit.api.menu.create;
        }else{
            url = this.$kit.api.menu.update;
        }

        delete this.menu.children;
        delete this.menu.parent;

        var _this = this;
        this.$axios.post(url, this.menu)
            .then(function(result){
                if(result.status){ 
                    _this.$message(result.msg || (_this.id==null? _this.msg("创建成功"): _this.msg('更新成功')));
                    if(result.status){
                        _this.$emit("close-dg", true);
                    }
                }else{
                    _this.$message(result.msg || (_this.id==null? _this.msg('创建失败'):_this.msg('更新失败')));
                }
               
            });
    },
    selectedMenuNode(menu, node, self){

        if(menu.id != this.menu.id){
            this.parent.name = menu.name;
            this.menu.parentId = menu.id;
            this.menusPopoverVisiable = false;
        }
    }
  }
}
</script>

<style scoped lang="scss">
.icon-list{ height: 400px; overflow-y: auto;margin:0px; padding:0px; display:flex; flex-wrap:wrap;  border: 1px solid #eaeefb;}
.icon-list li{cursor:pointer;
        padding:8px; border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;
        display:flex; flex-direction: column; justify-content: center; align-items:center;
}
.icon-list li i{font-size:18px;} 
.icon-list li:hover{color:#5CB6FF;}


</style>
